import { ACCEPT, BANNED } from "../../services/companies-statuses";

const COMPANIES_DATA_REQUEST = 'COMPANIES_DATA_REQUEST';
const COMPANIES_DATA_SUCCESS = 'COMPANIES_DATA_SUCCESS';
const COMPANIES_DATA_FAILURE = 'COMPANIES_DATA_FAILURE';
const COMPANIES_DATA_CHAHNGE_BY_ID = 'COMPANIES_DATA_CHAHNGE_BY_ID';
const COMPANIES_DATA_ADDED = 'COMPANIES_DATA_ADDED';

const MODERATED_COMPANIES_DATA_REQUEST = 'MODERATED_COMPANIES_DATA_REQUEST';
const MODERATED_COMPANIES_DATA_SUCCESS = 'MODERATED_COMPANIES_DATA_SUCCESS';
const MODERATED_COMPANIES_DATA_FAILURE = 'MODERATED_COMPANIES_DATA_FAILURE';
const MODERATED_COMPANIES_REMOVE_BY_ID = 'MODERATED_COMPANIES_REMOVE_BY_ID';

const DECLINED_COMPANIES_DATA_REQUEST = 'DECLINED_COMPANIES_DATA_REQUEST';
const DECLINED_COMPANIES_DATA_SUCCESS = 'DECLINED_COMPANIES_DATA_SUCCESS';
const DECLINED_COMPANIES_DATA_FAILURE = 'DECLINED_COMPANIES_DATA_FAILURE';

const CHANGE_DATA_BY_COMPANY_TYPE = 'CHANGE_DATA_BY_COMPANY_TYPE';

const initialState = {
  allCompanies: {
    loading: false,
    success: false,
    failure: false,
    last: false,
    data: null,
  },
  moderatedCompanies: {
    loading: false,
    success: false,
    failure: false,
    last: false,
    data: null,
  },
  declinedCompanies: {
    loading: false,
    success: false,
    failure: false,
    last: false,
    data: null,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPANIES_DATA_REQUEST:
      return {
        ...state,
        allCompanies: {
          loading: true,
          success: false,
          failure: false,
          last: false,
          data: null,
        },
      };
    case COMPANIES_DATA_SUCCESS:
      return {
        ...state,
        allCompanies: {
          loading: false,
          success: true,
          failure: false,
          last: action.payload.last,
          data: action.payload.data,
        },
      };
    case COMPANIES_DATA_ADDED:
      return {
        ...state,
        [action.payload.key]: {
          loading: false,
          success: true,
          failure: false,
          last: action.payload.last,
          data: action.payload.data,
          direction: action.payload.direction,
        },
      };
    case COMPANIES_DATA_FAILURE:
      return {
        ...state,
        allCompanies: {
          loading: false,
          success: false,
          failure: true,
          last: false,
          data: action.payload,
        },
      };
    case COMPANIES_DATA_CHAHNGE_BY_ID:
      const newData = [];
      let newDeclinedCompanies = [];
      let declinedElemIndex;
      for (let i = 0; i < state.allCompanies.data.length; i += 1) {
        if (action.payload.id === state.allCompanies.data[i].companyId) {
          newData.push({
            ...state.allCompanies.data[i],
            ...action.payload.data,
          });
          if (action.payload.data.status === BANNED) {
            newDeclinedCompanies = [
              {
                ...state.allCompanies.data[i],
                ...action.payload.data,
              },
              ...state.declinedCompanies.data,
            ];
          } else if (action.payload.data.status === ACCEPT) {
            declinedElemIndex = state.declinedCompanies.data.findIndex((el) => state.allCompanies.data[i].id === el.id);
            newDeclinedCompanies = [
              ...state.declinedCompanies.data.slice(0, declinedElemIndex),
              ...state.declinedCompanies.data.slice(declinedElemIndex + 1),
            ];
          }
        } else {
          newData.push(state.allCompanies.data[i]);
        }
      }
      return {
        ...state,
        allCompanies: {
          ...state.allCompanies,
          data: newData,
        },
        declinedCompanies: {
          ...state.declinedCompanies,
          data: newDeclinedCompanies,
        },
      };
    case MODERATED_COMPANIES_DATA_REQUEST:
      return {
        ...state,
        moderatedCompanies: {
          loading: true,
          success: false,
          failure: false,
          last: false,
          data: null,
        },
      };
    case MODERATED_COMPANIES_DATA_SUCCESS:
      return {
        ...state,
        moderatedCompanies: {
          loading: false,
          success: true,
          failure: false,
          last: action.payload.last,
          data: action.payload.data,
        },
      };
    case MODERATED_COMPANIES_DATA_FAILURE:
      return {
        ...state,
        moderatedCompanies: {
          loading: false,
          success: false,
          failure: true,
          last: false,
          data: action.payload,
        },
      };
    case MODERATED_COMPANIES_REMOVE_BY_ID:
      const newListData = [];
      for (let i = 0; i < action.payload.data.length; i += 1) {
        if (action.payload.data[i].companyId !== action.payload.id) {
          newListData.push(action.payload.data[i]);
        }
      }
      return {
        ...state,
        moderatedCompanies: {
          ...state.moderatedCompanies,
          data: newListData,
        },
      };
    case DECLINED_COMPANIES_DATA_REQUEST:
      return {
        ...state,
        declinedCompanies: {
          loading: true,
          success: false,
          failure: false,
          last: false,
          data: null,
        },
      };
    case DECLINED_COMPANIES_DATA_SUCCESS:
      return {
        ...state,
        declinedCompanies: {
          loading: false,
          success: true,
          failure: false,
          last: action.payload.last,
          data: action.payload.data,
        },
      };
    case DECLINED_COMPANIES_DATA_FAILURE:
      return {
        ...state,
        declinedCompanies: {
          loading: false,
          success: false,
          failure: true,
          last: false,
          data: action.payload,
        },
      };
    case CHANGE_DATA_BY_COMPANY_TYPE:
      return {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          ...action.payload.data,
        },
      };
    default:
      return state;
  }
};

export default reducer;

/**
 * Actions
 */

export const companiesDataRequest = () => ({
  type: COMPANIES_DATA_REQUEST,
});

export const companiesDataSuccess = (payload) => ({
  type: COMPANIES_DATA_SUCCESS,
  payload,
});

export const companiesDataFailure = (payload) => ({
  type: COMPANIES_DATA_FAILURE,
  payload,
});

export const companiesDataChangeById = (payload) => ({
  type: COMPANIES_DATA_CHAHNGE_BY_ID,
  payload,
});

export const moderatedCompaniesDataRequest = () => ({
  type: MODERATED_COMPANIES_DATA_REQUEST,
});

export const moderatedCompaniesDataSuccess = (payload) => ({
  type: MODERATED_COMPANIES_DATA_SUCCESS,
  payload,
});

export const moderatedCompaniesDataFailure = (payload) => ({
  type: MODERATED_COMPANIES_DATA_FAILURE,
  payload,
});

export const moderatedCompaniesRemoveById = (payload) => ({
  type: MODERATED_COMPANIES_REMOVE_BY_ID,
  payload,
});

export const companiesDataAdded = (payload) => ({
  type: COMPANIES_DATA_ADDED,
  payload,
});

export const declinedCompaniesDataRequest = () => ({
  type: DECLINED_COMPANIES_DATA_REQUEST,
});

export const declinedCompaniesDataSuccess = (payload) => ({
  type: DECLINED_COMPANIES_DATA_SUCCESS,
  payload,
});

export const declinedCompaniesDataFailure = (payload) => ({
  type: DECLINED_COMPANIES_DATA_FAILURE,
  payload,
});

export const changeDataByCompanyType = (payload) => ({
  type: CHANGE_DATA_BY_COMPANY_TYPE,
  payload,
});
